import { render, staticRenderFns } from "./BlogPostCard.vue?vue&type=template&id=4f2fa5e6&scoped=true&"
import script from "./BlogPostCard.vue?vue&type=script&lang=js&"
export * from "./BlogPostCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2fa5e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2fa5e6')) {
      api.createRecord('4f2fa5e6', component.options)
    } else {
      api.reload('4f2fa5e6', component.options)
    }
    module.hot.accept("./BlogPostCard.vue?vue&type=template&id=4f2fa5e6&scoped=true&", function () {
      api.rerender('4f2fa5e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Blog/BlogPostCard.vue"
export default component.exports